
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.706 10.037l-.457.212-1.414-3.033-.26-.559-.756.19h-3.12v.155h2.975l-.117.24H13.54V7.4h1.94l-.677 2.185-1.692.865c-.086 0-.263.009-.496.02-1.003.047-3.038.143-3.229-.171a.485.485 0 00-.017-.027l-.072-.126h-4.41v-.561h4.086l-.087-.153-1.183-2.057-.086-.15L6.233 9.43h-.602l1.7-2.709-.07-.12-.033-.005-2.604-.348-.317.21-.19-.21.377-.263-.006-.016a.543.543 0 01.03-.415l.065-.132a.506.506 0 01.49-.28l1.711.123c.277.02.794.221.794.221l1.059-.064h2.38c1.973-.186 3.046-.584 3.717-.833.34-.127.577-.215.777-.218l-.205-.365-1.188.319-.131-.488 1.393-.373a.252.252 0 01.293.137l1.612 3.386 1.421 3.049zm-.335-2.752c-.23 0-.453.03-.665.084l.425.913a1.652 1.652 0 011.89 1.632c0 .91-.74 1.65-1.65 1.65a1.648 1.648 0 01-1.095-2.883l-.425-.912a2.63 2.63 0 101.52-.485zM3.98 9.914c0 .91.74 1.65 1.65 1.65.777 0 1.43-.541 1.604-1.266h.997a2.63 2.63 0 11-1.567-2.8l-.53.845a1.652 1.652 0 00-2.154 1.57zm4.234-.483H7.207a1.656 1.656 0 00-.383-.653l.531-.847c.438.382.748.906.859 1.5z","fill":"currentColor"}})])
          )
        }
      }
    